<template>
  <div class="main-dashboard-panel">
    <div class="panel-topnav container-fluid">
      <ul class="nav nav-tabs">
        <li>
          <h3 class="page-title">
            My applications
          </h3>
        </li>
      </ul>
      <div class="clearfix"></div>
    </div>

    <div class="container-fluid pane">
      <ApplicationList />
    </div>
  </div>
</template>

<script>
import ApplicationList from './ApplicationList'

export default {
  components: { ApplicationList },
}
</script>
